/** Photography generated from the standing brief in docs/IMAGE-SYSTEM.md. */
export const workHeroImage: { image: string; alt: string } = {
  image:
    'https://cdn.magicpatterns.com/patterns/generated-images/c71f3e72-4aaa-4daa-b8d2-7b783ab84ee3.jpg',
  alt: 'Five abstract project boards arranged edge to edge and slightly overlapping on a pale studio table',
}

export const workInProgressImage: { image: string; alt: string; caption: string } = {
  image:
    'https://cdn.magicpatterns.com/patterns/generated-images/5ccb9989-70d2-4975-ba4f-cab53c5456d9.jpg',
  alt: 'A wall of abstract design printouts pinned in a measured grid under soft side light',
  caption: 'Work in progress, self-initiated.',
}
